import { Users, Wrench, ClipboardCheck, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";

const ADVANTAGES = [
  { icon: Users, title: "Persönliche Ansprechpartner", text: "Feste Ansprechpartner statt anonymer Hotline – bei uns kennen Sie Ihr Gegenüber." },
  { icon: Wrench, title: "Verkauf & Service aus einer Hand", text: "Beratung, Verkauf, Werkstatt und Unterhalt – alles an einem Standort." },
  { icon: ClipboardCheck, title: "Kompetente Flottenberatung", text: "Vom einzelnen Geschäftsfahrzeug bis zur kompletten Firmenflotte." },
  { icon: MapPin, title: "Regional im Zürcher Oberland", text: "Persönlich erreichbar in Hinwil – kurze Wege, schnelle Termine." },
];

export default function About() {
  return (
    <section data-testid="about-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          number="01"
          label="Künzler & Sauber AG"
          title="Persönlich. Familiär. Kompetent."
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <p className="text-lg sm:text-xl leading-relaxed text-neutral-700 font-light">
              Künzler &amp; Sauber AG steht für persönliche Beratung, langjährige Erfahrung und
              umfassenden Service rund um Ihre Mobilität.
            </p>
            <p className="mt-6 text-base leading-relaxed text-neutral-600">
              Als KIA Partner begleiten wir Unternehmen von der Auswahl des passenden Fahrzeugs
              über Finanzierung und Leasing bis hin zu Service und Unterhalt – persönlich,
              direkt und ohne Umwege.
            </p>
          </Reveal>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2">
            {ADVANTAGES.map((a, i) => (
              <Reveal key={a.title} delay={i * 0.08}>
                <div
                  data-testid={`about-advantage-${i}`}
                  className="group border border-neutral-200 p-8 h-full transition-colors duration-300 hover:bg-neutral-950"
                >
                  <a.icon size={22} strokeWidth={1.5} className="text-neutral-950 transition-colors group-hover:text-white" />
                  <h3 className="mt-6 text-lg font-medium tracking-tight text-neutral-950 transition-colors group-hover:text-white">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-600 transition-colors group-hover:text-neutral-400">
                    {a.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1} className="mt-20 sm:mt-28">
          <div data-testid="family-section">
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-neutral-500 mb-4">Das sind wir</div>
            <h3 className="text-2xl sm:text-3xl font-medium tracking-tight text-neutral-950 mb-8">
              Familienbetrieb mit 3 aktiven Generationen.
            </h3>
            <div className="overflow-hidden bg-neutral-100">
              <img
                src="https://customer-assets-cm19k8pv.emergentagent.net/job_kia-firmenkunden/artifacts/8imfl9x6_exec-48b3574d-aa21-4788-afdb-a16b89dd9589.png"
                alt="Stefan, Leon und Robert Haas – Künzler & Sauber AG"
                className="w-full aspect-[16/9] object-cover"
                data-testid="family-photo"
              />
            </div>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs">
              <div><span className="font-semibold text-neutral-950">Leon Haas</span><br /><span className="text-neutral-500">Buchhaltung / Administration</span></div>
              <div><span className="font-semibold text-neutral-950">Stefan Haas</span><br /><span className="text-neutral-500">Inhaber &amp; Geschäftsführer</span></div>
              <div><span className="font-semibold text-neutral-950">Robert Haas</span><br /><span className="text-neutral-500">Senior Chef</span></div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
